document.addEventListener('turbolinks:load', function() {

    /* global enlarge:true */
    (function($, window) {
      var initSelector, pluginName;
      pluginName = 'enlarge';
      initSelector = '.' + pluginName;
      $(document).on('enhance', function(e) {
        $(initSelector, e.target).each(function() {
          $(this)[pluginName]();
        });
      });
    })(jQuery, this);
    (function($) {
      $(function() {
        $('.enlarge.inline-demo').data('options', {
          button: true,
          hoverZoomWithoutClick: false,
          delay: 300,
          flyout: {
            width: 400,
            height: 400
          },
          placement: 'inline',
          magnification: 3
        });
        $(document).bind('enhance', function() {
          $('body').addClass('enhanced');
        });
        $(document).trigger('enhance');
      });
    })(jQuery);
  });
  